export default "__VITE_ASSET__be4c920a__"